<body>
    <nav-search-perfil-logo></nav-search-perfil-logo>
    <div style="padding-top: 1%; padding: 1%;">
        <app-breadcrumb></app-breadcrumb>
        <router-outlet [@scrollAnimation]="state"></router-outlet>
    </div>
</body>